import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const t = {
  distribution_list: 'List name',
};

const Offers = ({ changes, ...props }) => {
  return (
    <Spacer {...props}>
      {changes?.drivers?.map(({ contact_email, contact_name }) => (
        <Text color="grey900" display="block">
          {contact_name} - {contact_email}
        </Text>
      ))}
      {changes?.distribution_list_name && (
        <Text color="grey900" display="block">
          <strong>{t.distribution_list}:</strong> {changes.distribution_list_name}
        </Text>
      )}
    </Spacer>
  );
};

export default Offers;
